/* eslint-disable eslint-comments/no-unlimited-disable -- ok */
/* eslint-disable -- external script */
// @ts-nocheck - third party script

import { isDev } from '../consts/isDev'

// eslint-disable
export const LoadRum24x7 = (rumId: string) => {
    if (isDev) return
    ;(function (w, d, s, r, k, h, m) {
        if (w.performance && w.performance.timing && w.performance.navigation) {
            w[r] =
                w[r] ||
                function () {
                    ;(w[r].q = w[r].q || []).push(arguments)
                }
            h = d.createElement('script')
            h.async = true
            h.setAttribute('src', s + k)
            d.getElementsByTagName('head')[0].appendChild(h)
            ;((m = window.onerror),
                (window.onerror = function (b, c, d, f, g) {
                    ;(m && m(b, c, d, f, g),
                        g || (g = new Error(b as string)),
                        (w[r].q = w[r].q || []).push(['captureException', g]))
                }))
        }
    })(window, document, '//static.site24x7rum.eu/beacon/site24x7rum-min.js?appKey=', 's247r', rumId)
}
